/* BD HERBS — collection page: filter/sort popovers (bottom sheet on phones) and the description toggle.
   Paging is plain page-number links (snippets/bd-pagination.liquid), so Back / scroll / bfcache are the browser's own. */
(() => {
  if (window.bdCollectionReady) return; // the file can be included by more than one section
  window.bdCollectionReady = true;
  const isPhone = () => window.matchMedia('(max-width: 749px)').matches;

  /* ---------- <bd-popover>: wraps a <details>; closes on Esc / outside tap; one open at a time ---------- */
  if (!customElements.get('bd-popover')) {
    customElements.define(
      'bd-popover',
      class BdPopover extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('details');
          if (!this.details || this.bound) return; // reconnects must not add a second set of listeners
          this.bound = true;
          this.summary = this.details.querySelector('summary');
          this.onDocClick = this.onDocClick.bind(this);
          this.onKey = this.onKey.bind(this);

          this.details.addEventListener('toggle', () => {
            if (this.details.open) {
              document.querySelectorAll('bd-popover details[open]').forEach((d) => d !== this.details && (d.open = false));
              document.addEventListener('click', this.onDocClick);
              document.addEventListener('keydown', this.onKey);
              if (isPhone()) document.body.classList.add('overflow-hidden-mobile');
              const first = this.details.querySelector('input:checked, input:not([type="hidden"]), button[type="submit"]');
              if (first) first.focus({ preventScroll: true });
            } else {
              document.removeEventListener('click', this.onDocClick);
              document.removeEventListener('keydown', this.onKey);
              if (!document.querySelector('bd-popover details[open]')) document.body.classList.remove('overflow-hidden-mobile');
            }
          });

          // Sorting applies as soon as an option is picked
          const sortForm = this.querySelector('[data-sort-form]');
          if (sortForm) {
            sortForm.addEventListener('change', () => {
              if (typeof sortForm.requestSubmit === 'function') sortForm.requestSubmit();
              else sortForm.submit();
            });
          }
        }

        close(returnFocus = true) {
          this.details.open = false;
          if (returnFocus) this.summary.focus({ preventScroll: true });
        }

        onDocClick(event) {
          // Outside the popover, or on the dimmed backdrop (the <details> itself on phones)
          if (!this.contains(event.target) || event.target === this.details) this.close(false);
        }

        onKey(event) {
          if (event.key === 'Escape') this.close();
        }
      }
    );
  }

  /* ---------- Description: hide "আরও পড়ুন" when the text already fits ---------- */
  const checkDescriptions = () => {
    document.querySelectorAll('[data-desc]').forEach((wrap) => {
      const body = wrap.querySelector('[data-desc-body]');
      const check = wrap.querySelector('[data-desc-check]');
      if (!body || !check || check.checked) return;
      wrap.classList.toggle('is-short', body.scrollHeight <= body.clientHeight + 2);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkDescriptions);
  else checkDescriptions();
  window.addEventListener('resize', checkDescriptions, { passive: true });
  document.addEventListener('shopify:section:load', checkDescriptions);
})();
